module.exports = __webpack_public_path__ + "img/logo-mvc.0b465a36.png";